module.exports = __webpack_public_path__ + "img/tro.c854b39d.png";